import React, { useState, useEffect } from 'react';
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import MenuItem from '@material-ui/core/MenuItem';
import { TextField, Select } from '@material-ui/core';
import * as authApi from '../../services/api/auth';

const moment = extendMoment(Moment);

const TimeSelect = ({
  label,
  name,
  time,
  increments = 5,
  onChange,
  className,
  helperText,
  error,
  disabled = false,
  fullWidth = true,
}) => {
  const value = time ? moment(time).valueOf() : '';
  const now = time ? moment(time) : moment('1970-01-01');

  const [currentUser, setCurrentUser] = useState({});
  const [start, setStart] = useState('');
  const [end, setEnd] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const fetchedCurrentUser = await authApi.fetchCurrentUser();
        const providerID = fetchedCurrentUser.provider.id;
        // setCurrentUser(fetchedCurrentUser);

        //const now = moment();
        const startValue = moment(now).startOf('day').add(6, 'hour');        
        const endValue = moment(now).endOf('day').subtract(65, 'm');

        setStart(startValue);
        setEnd(endValue);
      } catch (error) {
        console.error('Error fetching user:', error);
      }
    })();
  }, []);

  //  Previous Code
  // const start = moment(now).startOf('day');

  // Day starts form 6 am morning, So added 6 hours and subtract 55 minutes
  // So slot starts from 6 am and ends from 11 pm

  // const start = moment(now)
  //   .startOf('day')
  //   .add(6, 'hour');
  // const end = moment(now)
  //   .endOf('day')
  //   .subtract(55, 'm');

  // The below condition is to wait untill we get valid value for start and end.
  if (!start || !end) return null;

  const range = moment.range(start, end);

  const times = Array.from(
    range.by('minute', { excludeEnd: false, step: increments })
  );

  const props = {
    disabled,
    fullWidth,
    label,
    name,
    value,
    onChange,
    className,
    variant: 'outlined',
    helperText,
    error,
  };

  const items = times.map((t) => {
    return (
      <MenuItem value={t.valueOf()} key={t.valueOf()}>
        {t.format('hh:mma')}
      </MenuItem>
    );
  });

  return (
    <TextField select {...props}>
      {items}
    </TextField>
  );
};

export default TimeSelect;
